// RoleRedirect.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RoleRedirect = () => {
  const navigate = useNavigate();
const { user } = useAuth();
  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    } else {
      switch (user.role) {
        case 'admin':
          navigate('/admin/dashboard', { replace: true });
          break;
        case 'staff':
          navigate('/staff/dashboard', { replace: true });
          break;
        case 'trainer':
          navigate('/manager/dashboard', { replace: true });
          break;
        default:
          navigate('/login', { replace: true });
      }
    }
  }, [user, navigate]);

  return null; 
};

export default RoleRedirect;
